import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
  cancelAnimation,
} from 'react-native-reanimated';

const ICON_SIZE = 20;

interface RecordingStatusBadgeProps {
  readonly isPaused: boolean;
  readonly label: string;
}

export const RecordingStatusBadge = ({ isPaused, label }: RecordingStatusBadgeProps) => {
  const opacity = useSharedValue(1);

  useEffect(() => {
    if (isPaused) {
      cancelAnimation(opacity);
      opacity.value = withTiming(1, { duration: 200 });

      return;
    }

    opacity.value = withRepeat(
      withSequence(withTiming(0.4, { duration: 800 }), withTiming(1, { duration: 800 })),
      -1,
      true,
    );

    return () => cancelAnimation(opacity);
  }, [opacity, isPaused]);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  const iconName = isPaused ? 'pause' : 'radiobox-marked';
  const iconColor = isPaused ? '#a95700' : '#e03131';
  const backgroundColor = isPaused ? '#fff3bf' : '#ffe3e3';
  const textColor = isPaused ? '#a95700' : '#c92a2a';

  return (
    <View style={[styles.container, { backgroundColor }]}>
      <Animated.View style={animatedStyle}>
        <MaterialCommunityIcons color={iconColor} name={iconName} size={ICON_SIZE} />
      </Animated.View>
      <Text variant="titleSmall" style={{ color: textColor }}>
        {label}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 16,
    paddingVertical: 4,
    borderRadius: 8,
  },
});
